export default __webpack_public_path__ + "static/media/no-image-available-full-trans-2.be083b03.png";